import React from 'react';
import Icon from 'components/Icon';
import classNames from 'lib/classNames';

const Tag = ({
	image,
	title,
	id,
	onClose,
	style = {
		background: null,
		color: null,
	},
}) => {
	return (
		<div
			className={classNames('w-full p-2 relative inline-flex items-center flex-row bg-white rounded shadow')}
			style={{
				background: style.background,
			}}
		>
			{image && (
				<img
					style={{ width: 30, height: 30 }}
					src={typeof image === 'string' ? image : image.src}
					alt={title}
				/>
			)}
			{!image && (
				<div
					style={{ fill: '#c4cdd5', width: 30, height: 30, padding: 0 }}
					className={classNames('text-transparent')}
				>
					<svg viewBox="0 0 20 20" className={classNames('w-full h-full')}>
						<path fill="currentColor" d="M14 9l-5 5-3-2-5 3v4h18v-6z"></path>
						<path d="M19 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM8 6c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.654 0 3-1.346 3-3S9.654 4 8 4 5 5.346 5 7s1.346 3 3 3zm-6 8v-2.434l3.972-2.383 2.473 1.65c.398.264.925.21 1.262-.126l4.367-4.367L18 13.48V18H2zM18 2v8.92l-3.375-2.7a.999.999 0 0 0-1.332.073l-4.42 4.42-2.318-1.545a1 1 0 0 0-1.07-.025L2 13.233V2h16z"></path>
					</svg>
				</div>
			)}
			<div
				className={classNames('mx-2 flex-1 text-xs font-bold capitalize text-gray-700 truncate ...')}
				style={{ color: style.color }}
			>
				{title}
			</div>
			<i
				className={classNames('text-red-500')}
				onClick={() => onClose(id)}
				style={{
					background: style.color,
				}}
			>
				<Icon
					icon="times"
					size="xs"
					style={{
						color: style.background,
					}}
					className="cursor-pointer"
				/>
			</i>
		</div>
	);
};

export default Tag;
